import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Grid,
  Box,
  Tabs,
  Tab,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import {
  grey,
} from '@material-ui/core/colors';

import { a11yProps } from '../helpers';
import TabPanel from '../components/common/TabPanel';
import VerificationTable from '../components/tables/VerificationTable';
import { selectUserClientId } from '../store/authSlice';
import { selectCompanyCode, selectVerificationList, getVerificationList } from '../store/widgetSlice';

const useStyles = makeStyles(() => ({
  root: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  tabContainer: {
    borderBottomColor: grey[400],
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
  },
}));

export default function Verifications() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const clientId = useSelector(selectUserClientId);
  const companyCode = useSelector(selectCompanyCode);
  const verifications = useSelector(selectVerificationList);
  const [value, setValue] = useState(0);
  const [currentCompanyCode, setCurrentCompanyCode] = useState(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (value === 0
      && clientId
      && (currentCompanyCode !== companyCode)) {
      dispatch(getVerificationList({ companyCode }));
    } else if (!clientId && (currentCompanyCode !== companyCode)) {
      dispatch(getVerificationList({ companyCode }));
    }
  }, [dispatch, value, clientId, verifications, companyCode, currentCompanyCode]);

  useEffect(() => {
    if (currentCompanyCode !== companyCode) {
      setCurrentCompanyCode(companyCode);
    }
  }, [dispatch, companyCode, currentCompanyCode]);

  return (
    <>
      <Grid item xs={12}>
        <Box className={classes.root}>
          <Box className={classes.tabContainer}>
            <Tabs value={value} onChange={handleChange} aria-label="Import Type">
              <Tab label="Verifications" {...a11yProps(0)} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <VerificationTable rows={verifications} />
          </TabPanel>
        </Box>
      </Grid>
    </>
  );
}
